// // components/chapter/redux/chapterThunk.js
// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { API_URL_QUESTION_BANK } from "../../SchoolModule/Webservices/api";
// const API_BASE_URL = API_URL_QUESTION_BANK;
// export const fetchClassesThunk = createAsyncThunk(
//   "chapter/fetchClasses",
//   async () => {
//     const res = await fetch(`${API_BASE_URL}/classes`);
//     if (!res.ok) throw new Error("Failed to fetch classes");
//     return await res.json();
//   }
// );

// export const fetchSubjectsByClassThunk = createAsyncThunk(
//   "chapter/fetchSubjects",
//   async (classId) => {
//     const res = await fetch(`${API_BASE_URL}/subjects/link/${classId}`);
//     if (!res.ok) throw new Error("Failed to fetch subjects");
//     return await res.json();
//   }
// );

// export const fetchChaptersThunk = createAsyncThunk(
//   "chapter/fetchChapters",
//   async ({ classId, subjectId }) => {
//     const res = await fetch(
//       `${API_BASE_URL}/chapters?subject_id=${subjectId}&class_id=${classId}`
//     );
//     if (!res.ok) throw new Error("Failed to fetch chapters");
//     return await res.json();
//   }
// );

// export const createChapterThunk = createAsyncThunk(
//   "chapter/createChapter",
//   async (payload) => {
//     const res = await fetch(`${API_BASE_URL}/chapters`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });
//     if (!res.ok) throw new Error("Failed to create chapter");
//     return await res.json();
//   }
// );

// export const updateChapterThunk = createAsyncThunk(
//   "chapter/updateChapter",
//   async ({ chapterId, payload }) => {
//     const res = await fetch(`${API_BASE_URL}/chapters/${chapterId}`, {
//       method: "PUT",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });
//     if (!res.ok) throw new Error("Failed to update chapter");
//     return await res.json();
//   }
// );

// export const deleteChapterThunk = createAsyncThunk(
//   "chapter/deleteChapter",
//   async (chapterId) => {
//     const res = await fetch(`${API_BASE_URL}/chapters/${chapterId}`, {
//       method: "DELETE",
//     });
//     if (!res.ok) throw new Error("Failed to delete chapter");
//     return chapterId;
//   }
// );
// components/chapter/redux/chapterThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import { getClasses, getSubjects, chapters } from "../config";

const getErrorMessage = (error, fallbackMessage) =>
  error.response?.data?.message || error.message || fallbackMessage;

const requestConfig = () => ({
  headers: apiKeyHeader(),
});

async function GETAPIREQUEST(url, type, rejectWithValue) {
  try {
    const response = await axios.get(url, requestConfig());
    return response.data;
  } catch (err) {
    return rejectWithValue(
      getErrorMessage(err, "Network error while fetching " + type)
    );
  }
}

export const fetchClassesThunk = createAsyncThunk(
  "chapter/fetchClasses",
  async (_, { rejectWithValue }) => {
    return GETAPIREQUEST(getClasses, "Classes", rejectWithValue);
  }
);

export const fetchSubjectsByClassThunk = createAsyncThunk(
  "chapter/GetSubjectsThunk",
  async (classId, { rejectWithValue }) => {
    console.log("classId", classId);
    const URL = getSubjects + classId;
    return GETAPIREQUEST(URL, "Subjects", rejectWithValue);
  }
);

export const fetchChaptersThunk = createAsyncThunk(
  "chapter/fetchChaptersThunk",
  async ({ subjectId, classId }, { rejectWithValue }) => {
    const URL = chapters + `?subject_id=${subjectId}&class_id=${classId}`;
    return GETAPIREQUEST(URL, "Chapters", rejectWithValue);
  }
);
// export const fetchChaptersThunk = createAsyncThunk(
//   "chapter/fetchChapters",
//   async ({ classId, subjectId }) => {
//     const res = await fetch(
//       `${chapters}?subject_id=${subjectId}&class_id=${classId}`,
//       {
//         method: "GET",
//         headers: apiKeyHeader(),
//       }
//     );
//     if (!res.ok) throw new Error("Failed to fetch chapters");
//     return await res.json();
//   }
// );

export const createChapterThunk = createAsyncThunk(
  "chapter/createChapter",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(chapters, payload, requestConfig());
      return response.data;
    } catch (error) {
      return rejectWithValue(
        getErrorMessage(error, "Failed to create chapter")
      );
    }
  }
);

export const updateChapterThunk = createAsyncThunk(
  "chapter/updateChapter",
  async ({ chapterId, payload }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${chapters}/${chapterId}`,
        payload,
        requestConfig()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        getErrorMessage(error, "Failed to update chapter")
      );
    }
  }
);

export const deleteChapterThunk = createAsyncThunk(
  "chapter/deleteChapter",
  async (chapterId, { rejectWithValue }) => {
    try {
      await axios.delete(`${chapters}/${chapterId}`, requestConfig());
      return chapterId;
    } catch (error) {
      return rejectWithValue(
        getErrorMessage(error, "Failed to delete chapter")
      );
    }
  }
);
